const BASE_URL = `https://${import.meta.env.VITE_REACT_APP_API_ENDPOINT}`;
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const getInitialQuestion = async (getIdTokenClaims, getAccessTokenWithPopup, logout, queryParam) => {
    try {
        const res = await axios.post(
            `${BASE_URL}/initialize`,
            {
                client_id: queryParam ? queryParam : null,
            },
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                getInitialQuestion(getIdTokenClaims, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                console.log(refreshError)
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
        }
    }
}

const sendQuestionRequest = async (getIdTokenClaims, getAccessTokenWithPopup, logout, question, clientId, questionKey) => {
    try {
        const res = await axios.post(
            `${BASE_URL}/question`,
            {
                question: question,
                pusher: true,
                client_id: clientId ? clientId : null,
                question_key: questionKey ? questionKey : null
            },
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                sendQuestionRequest(question, showMore);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
        }
    }
}

const sendListingActionRequest = async (answer_hash, action) => {
    try {
        var url = `${BASE_URL}/answer/${answer_hash}/${action}`
        const res = await axios.post(url);
        return res;
    } catch (error) {
        console.log(error)
    }
}

const getMLSList = async () => {
    try {
        var url = `${BASE_URL}/mls_list`
        var res = await axios.get(url);
        return res.data.data;
    } catch (error) {
        console.log(error);
        return []
    }
}

const addClientNote = async (clientId, answer_hash, note, getIdTokenClaims, getAccessTokenWithPopup, logout) => {
    try {
        let url = `${BASE_URL}/user/client/${clientId}/${answer_hash}/note`
        const res = await axios.post(
            url,
            {
                note: note
            },
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res.data.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                addClientNote(clientId, answer_hash, note, getIdTokenClaims, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false
        }
    }
}

const updateClientNote = async (noteId, note, getIdTokenClaims, getAccessTokenWithPopup, logout) => {
    try {
        let url = `${BASE_URL}/user/note/${noteId}`
        const res = await axios.patch(
            url,
            {
                note: note
            },
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return true;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                updateClientNote(noteId, note, getIdTokenClaims, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false
        }
    }
}

const deleteClientNote = async (noteId, getIdTokenClaims, getAccessTokenWithPopup, logout) => {
    try {
        let url = `${BASE_URL}/user/note/${noteId}`
        const res = await axios.delete(
            url,
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return true;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                deleteClientNote(noteId, getIdTokenClaims, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false
        }
    }

}

const updateUser = async (getIdTokenClaims, body, checkMLS, getAccessTokenWithPopup, logout) => {
    try {
        const res = await axios.patch(
            BASE_URL + '/user',
            body,
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        if (checkMLS) {
            if (res.data.message.app_metadata.mls_active)
                return true;
            else
                return false;
        }

        return true;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                updateUser(getIdTokenClaims, body, checkMLS, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false;
        }
    }
}

const getClients = async (getIdTokenClaims, getAccessTokenWithPopup, logout) => {
    try {
        const res = await axios.get(
            BASE_URL + '/user/clients',
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res.data.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                getClients(getIdTokenClaims, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                console.log(refreshError)
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
        }
    }
}

const createClient = async (getIdTokenClaims, clientName, clientDescription, getAccessTokenWithPopup, logout) => {
    try {
        const res = await axios.post(
            BASE_URL + '/user/client',
            {
                name: clientName,
                description: clientDescription
            },
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return true;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                createClient(getIdTokenClaims, clientName, clientDescription, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false;
        }
    }
}

const saveClientList = async (getIdTokenClaims, clientId, answer_hash, getAccessTokenWithPopup, logout) => {
    try {
        let url = `${BASE_URL}/user/client/${clientId}/${answer_hash}`
        const res = await axios.post(
            url, {},
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        registerUserFavorite(answer_hash, getIdTokenClaims, getAccessTokenWithPopup, logout);
        return true;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                saveClientList(getIdTokenClaims, clientId, answer_hash, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false
        }
    }
}

const unsaveClientList = async (getIdTokenClaims, clientId, answer_hash, getAccessTokenWithPopup, logout) => {
    try {
        let url = `${BASE_URL}/user/client/${clientId}/${answer_hash}`
        const res = await axios.delete(
            url,
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return true;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                unsaveClientList(getIdTokenClaims, clientId, answer_hash, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false
        }
    }
}

const getClientSavedListings = async (getIdTokenClaims, clientId, getAccessTokenWithPopup, logout) => {
    try {
        const res = await axios.get(
            BASE_URL + '/user/client/' + clientId + '/listings',
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res.data.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                getClientSavedListings(getIdTokenClaims, clientId, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
        }
    }
}

const getListingDetails = async (getIdTokenClaims, answer_hash, getAccessTokenWithPopup, logout) => {
    try {
        const res = await axios.get(
            BASE_URL + '/answer/' + answer_hash,
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                getListingDetails(getIdTokenClaims, answer_hash, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
        }
    }
}

const registerUserFavorite = async (answer_hash, getIdTokenClaims, getAccessTokenWithPopup, logout) => {
    try {
        let url = `${BASE_URL}/answer/${answer_hash}/favorite`
        const res = await axios.post(
            url, {},
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return true;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                registerUserFavorite(answer_hash, getIdTokenClaims, getAccessTokenWithPopup, logout);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
            return false
        }
    }
}

const getChatHistoryByClient = async (clientId, getIdTokenClaims, getAccessTokenWithPopup, logout) => {
    try {
        const res = await axios.get(
            `${BASE_URL}/user/client/${clientId}/history`,
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res.data.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                getChatHistoryByClient(clientId, getIdTokenClaims);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
            }
        }
        else {
            console.log(error)
        }
    }
}

const extractRawToken = async (getIdTokenClaims, logout) => {
    try {
        var res = (await getIdTokenClaims()).__raw;
        return res;
    } catch (ex) {
        logout({ returnTo: window.location.origin });
    }

}

const getUser =  async (idToken) => {
    let user = null;
    const response = await axios.get(
        `https://${import.meta.env.VITE_REACT_APP_API_ENDPOINT}/user`,
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${idToken}`,
            },
        }
    );
    if (response.data.success) {
        if(response.data.data) {
            user = response.data.data;
        }
    }
    return user;
}


const verifyCardOnFile = async (idToken, paymentPlan) => {
    let card_on_file = false, decodedToken = jwtDecode(idToken)
    const response = await axios.get(
        `https://${import.meta.env.VITE_REACT_APP_API_ENDPOINT}/user`,
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${idToken}`,
            },
        }
    );
    if (response.data.success) {
        card_on_file = response.data.data.card_on_file;
    } else {
        card_on_file = false;
    }
    if (!card_on_file) {
        if (!paymentPlan) {
            paymentPlan = decodedToken.plan_type;
        }
        const paymentResponse = await axios.post(
            `https://${import.meta.env.VITE_REACT_APP_API_ENDPOINT}/payment`,
            { payment_plan: paymentPlan },
            {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                },
            }
        );

        if (paymentResponse.data.success) {
            window.location.href = paymentResponse.data.redirect_url;
            localStorage.removeItem("plan_type");
        } else {
            alert("Payment failed: " + paymentResponse.data.message);
        }
    }
    return card_on_file;
}

const initializeWidget = async (widgetKey) => {
    try {
        const res = await axios.post(
            `${BASE_URL}/widget/initialize`,
            {
                widget_key: widgetKey
            }
        );
        return res.data;
    } catch (error) {
        return null;
    }
}

const sendWidgetAnswer = async (answer, token) => {
    try {
        const res = await axios.post(
            `${BASE_URL}/widget/chat`,
            {
                answer: answer
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return res.data;
    } catch (error) {
        return null;
    }
}

const getWidgetListings = async (token) => {
    try {
        const res = await axios.get(
            `${BASE_URL}/widget/listings`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return res.data;
    } catch (error) {
        return null;
    }
}

// Add to apiHandler.js
const convertSpeechToText = async (getIdTokenClaims, getAccessTokenWithPopup, logout, audioData) => {
    try {
        const res = await axios.post(
            `${BASE_URL}/stt`,
            {
                audio: audioData,
                content_type: 'audio/wav'
            },
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
            }
        );
        return res.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                return convertSpeechToText(getIdTokenClaims, getAccessTokenWithPopup, logout, audioData);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
                return null;
            }
        }
        console.log(error);
        return null;
    }
};

const convertTextToSpeech = async (getIdTokenClaims, getAccessTokenWithPopup, logout, text) => {
    try {
        const res = await axios.post(
            `${BASE_URL}/tts`,
            { text },
            {
                headers: {
                    Authorization: `Bearer ${(await extractRawToken(getIdTokenClaims, logout))}`,
                },
                responseType: 'blob'
            }
        );
        return res.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            try {
                // Try to refresh the token
                await getAccessTokenWithPopup();
                // Retry the API request
                return convertTextToSpeech(getIdTokenClaims, getAccessTokenWithPopup, logout, text);
            } catch (refreshError) {
                // If refreshing the token fails, log the user out
                logout({ returnTo: window.location.origin });
                return null;
            }
        }
        console.error('Error in TTS API call:', error);
        return null;
    }
};

// Add exports to the existing exports at the bottom
export {
    getInitialQuestion,
    sendQuestionRequest,
    sendListingActionRequest,
    getMLSList,
    updateUser,
    getClients,
    createClient,
    getClientSavedListings,
    getListingDetails,
    addClientNote,
    updateClientNote,
    deleteClientNote,
    saveClientList,
    unsaveClientList,
    registerUserFavorite,
    getChatHistoryByClient,
    verifyCardOnFile,
    initializeWidget,
    sendWidgetAnswer,
    getWidgetListings,
    getUser,
    convertSpeechToText,
    convertTextToSpeech
};